import React, { useEffect } from 'react';
import { actions } from 'redux/actions';
import { useSelector } from 'react-redux';
import { _t, createLink } from 'utils';
import PropertiesTableComponent from 'screens/shared/properties-table';
import moment from 'moment';
import { ACTIONS_TYPES } from 'redux/helper';
import NicsComponent from 'screens/shared/nics';
import Shared from 'screens/shared';
import CreateForm from 'screens/shared/lans/create';
import { ROUTE } from 'constant';

export default ({ history = {}, match }) => {
  const { dcId, id } = match.params;
  const { [ACTIONS_TYPES.LAN.GET]: lan = {} } = useSelector((e) => e);
  const { properties = {}, metadata = {}, entities = {} } = lan;

  useEffect(() => {
    actions.lan.get({ dcId, id });
  }, [dcId, id]);

  const propertiesRows = [
    ['Type', properties?.public ? _t('Public') : 'Private'],
    [_t('Last Updated'), moment(metadata.lastModifiedDate).fromNow()],
  ];

  const deleteHandler = () => {
    actions.lan.delete({ dcId, id });
    history.push(createLink(ROUTE.DASHBOARD.DATA_CENTER, { id: dcId }));
  };

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.LAN}
      strapIcon="ethernet"
      strapTitle={`LAN ${id} ${properties?.name ? `- ${properties?.name}` : ''}`}
      editForm={<CreateForm lan={{ id, name: properties?.name, public: properties?.public }} />}
      editAction={ACTIONS_TYPES.LAN.UPDATE}
      onDelete={deleteHandler}
    >
      <PropertiesTableComponent properties={propertiesRows} />
      <NicsComponent nics={entities?.nics?.items || []} history={history} dcId={dcId} readonly />
    </Shared.widgets.Page>
  );
};
